import styled from 'styled-components';

import { Skeleton } from '@gympass/yoga';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const Line = styled(Skeleton).attrs({
  width: 0,
  height: 0,
  type: 'rectangular',
})`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  height: ${({ theme }) => theme.yoga.spacing.xhuge}px;
  width: 100%;

  & + & {
    margin-top: ${({ theme }) => theme.yoga.spacing.xsmall}px;
  }
`;

export const LineSmall = styled(Skeleton).attrs({
  width: 0,
  height: 0,
  type: 'rectangular',
})`
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  height: ${({ theme }) => theme.yoga.spacing.large}px;
  width: 100%;
`;

export const LineSmallContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  &:nth-child(1) {
    margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
  }

  & + & {
    margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
    padding-top: ${({ theme }) => theme.yoga.spacing.small}px !important;
    border-top: ${({ theme }) =>
      `${theme.yoga.borders.small}px solid ${theme.yoga.colors.tableBorder}`};
  }
`;

export const LineMediumContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  &:nth-child(1) {
    margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
  }

  & + & {
    margin-top: ${({ theme }) => theme.yoga.spacing.medium}px;
    padding-top: ${({ theme }) => theme.yoga.spacing.medium}px !important;
    border-top: ${({ theme }) =>
      `${theme.yoga.borders.small}px solid ${theme.yoga.colors.tableBorder}`};
  }
`;

export const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;
